import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";

interface DoomsdaySliderProps {
  value: number;
  onChange: (v: number) => void;
  max?: number;
}

export default function DoomsdaySlider({ value, onChange, max = 10 }: DoomsdaySliderProps) {
  return (
    <div className="rounded-2xl border border-border bg-card p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-sm font-semibold">Fast-forward the disaster</div>
          <div className="text-xs text-muted-foreground">
            What if the loss happens {value === 0 ? "today" : `${value} year${value === 1 ? "" : "s"} from now`}?
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min={0}
            max={max}
            value={value}
            onChange={(e) => {
              const n = Math.min(max, Math.max(0, Number(e.target.value) || 0));
              onChange(n);
            }}
            className="h-8 w-16 text-center text-sm tabular-nums"
            aria-label="Years from now"
          />
          <span className="text-xs text-muted-foreground">yr</span>
        </div>
      </div>
      <Slider
        value={[value]}
        min={0}
        max={max}
        step={1}
        onValueChange={(v) => onChange(v[0] ?? 0)}
        aria-label="Years from now"
      />
      <div className="flex justify-between text-[10px] uppercase tracking-wide text-muted-foreground mt-2">
        <span>Today</span>
        <span>+{max} yrs</span>
      </div>
    </div>
  );
}
